import { createAction } from '@reduxjs/toolkit'

export const fetchArcCategories = createAction('arcCategories/fetchArcCategories')
export const fetchArcCategoriesSuccess = createAction('arcCategories/fetchArcCategoriesSuccess')
export const fetchArcCategoriesFailure = createAction('arcCategories/fetchArcCategoriesFailure')

export const createArcCategory = createAction('arcCategories/createArcCategory')
export const createArcCategorySuccess = createAction('arcCategories/createArcCategorySuccess')
export const createArcCategoryFailure = createAction('arcCategories/createArcCategoryFailure')

export const updateArcCategory = createAction('arcCategories/updateArcCategory')
export const updateArcCategorySuccess = createAction('arcCategories/updateArcCategorySuccess')
export const updateArcCategoryFailure = createAction('arcCategories/updateArcCategoryFailure')

export const deleteArcCategory = createAction('arcCategories/deleteArcCategory')
export const deleteArcCategorySuccess = createAction('arcCategories/deleteArcCategorySuccess')
export const deleteArcCategoryFailure = createAction('arcCategories/deleteArcCategoryFailure')

export const startSaving = createAction('arcCategories/startSaving')
export const finishSaving = createAction('arcCategories/finishSaving')